import React, {FC, useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import { toast } from 'react-toastify';
// custom
import { getAllPayments, getAllPromotionsAdmin, getEvents } from '../../common/async/AsyncCalls';
import { IEvent } from '../../common/state/events/event';
import { IPayment } from '../../common/state/payments/payment';
import {IUserState} from '../../common/state/profile/user';
import { IPromotion } from '../../common/state/promotions/promotion';
import SimpleSpinner from '../../components/loaders/spinners/SimpleSpinner';
import NavbarAdmin from '../../components/navbar/Navbar.admin';
import EventOverviewMuiTableAdmin from '../../components/tables/Event.overview.material.table';
import PromotionOverviewMuiTableAdmin from '../../components/tables/Promotion.overview.material.table';
import PaymentOverviewMuiTableAdmin from '../../components/tables/Payment.overview.material.table';
// custom

const AdminView : FC = () => {
    // states
    const [isLoading, toggleLoading] = useState(true);
    const [eventList, setEventList] = useState<IEvent[] | undefined>(undefined);
    const [promotionList, setPromotionList] = useState<IPromotion[] | undefined>(undefined);
    const [paymentList, setPaymentList] = useState<IPayment[] | undefined>(undefined);    
    const userProfile = useSelector(({user} : {
        user: IUserState
    }) => user.profile);
    const token = useSelector(({user} : {
        user: IUserState
    }) => user.token);

    // lifecycle
    const fetchAllDetails = useCallback(async ()=>{
        // console.log('Admin Dashboard - Access Token is: ', token);
        if (!token || token === '') return;
        const promiseList = [getEvents(), getAllPayments(), getAllPromotionsAdmin(token)];
        try {
            const responseList = await Promise.all(promiseList);
            const [eventResponse, paymentResponse, promotionResponse] = responseList;
            setPaymentList(paymentResponse?.data);
            setPromotionList(promotionResponse?.data);
            setEventList(eventResponse?.data);
        } catch (err) {
            console.log('Error fetching details: ', err);
            toast('Error fetching details');
        } finally {
            toggleLoading(false);
        }
    },[token]);

    // componentDidMount
    useEffect(()=>{
       fetchAllDetails();        
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="flex flex-col items-center justify-start h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
            <header
                className="flex justify-end w-full px-6 py-2 bg-gray-300 shadow-md dark:bg-gray-700">
                {userProfile.name}
                (Admin)
            </header>
            <section className="flex flex-col self-start w-full px-6 py-2">
                <h2 className="w-full my-2 text-2xl">Overview</h2>    
                <p className="self-start mb-4 text-gray-700 dark:text-gray-300 dartext-base">
                    Welcome to Admin Dashboard. You can see overview of Events, Promotions and Payments. In order to manage them, click
                    on the links in the navbar.
                </p>        
            </section>            
            <SimpleSpinner title='Loading events, payments, promotions...' loading={isLoading}/>
            <section
                className="flex flex-col w-full px-6 py-1 mb-4 text-gray-700 dark:text-gray-300 dartext-base">
                    <EventOverviewMuiTableAdmin list={eventList}/>
                    <hr className="inline-flex w-full my-2 border-gray-400 border-dashed border-bottom dark:border-gray-300"/>
                    <PromotionOverviewMuiTableAdmin list={promotionList}/>
                    <hr className="inline-flex w-full my-2 border-gray-400 border-dashed border-bottom dark:border-gray-300"/>
                    <PaymentOverviewMuiTableAdmin list={paymentList}/>
            </section>
        </div>
    </React.Fragment>;
};

export default AdminView;
